let averageDiffs = (rest, grocery, trans, sal, apt) => {
  return ((rest + grocery + trans + sal + apt) / 5).toFixed(2);
};

export default averageDiffs;
